import { styled } from 'styled-components';
import { COLORS, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import { ConversationStatus } from '@/models/conversation.model';
import { LinkButton } from '@/ui';

const statusColors: { [key in ConversationStatus]: { color: string; background: string } } = {
  [ConversationStatus.IN_PROGRESS]: { color: COLORS.STATUS_WARNING, background: 'rgba(247, 166, 46, 0.12)' },
  [ConversationStatus.COMPLETED]: { color: COLORS.STATUS_SUCCESS, background: 'rgba(14, 154, 78, 0.12)' },
};

export const StyledStatusPill = styled.div<{ $status: ConversationStatus }>`
  display: inline-flex;
  border-radius: 999px;
  align-items: center;
  padding: 0.25rem 0.6875rem;
  ${pickThemeFontStyles('12', '16', 'BOLD')}
  color: ${({ $status }) => statusColors[$status].color};
  background-color: ${({ $status }) => statusColors[$status].background};
`;

export const StyledCountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.625rem;
  height: 1.625rem;
  border-radius: 999px;
  padding: 0 0.5rem;
  background-color: ${COLORS.GRAY_1};
  color: ${COLORS.TEXT_SECONDARY};
  ${pickThemeFontStyles('13', '18', 'BOLD')}
`;

export const StyledSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;

  input,
  .ant-select {
    width: 100% !important;
  }

  input.ant-input {
    font-size: ${pickThemeFontSize('14')};
  }
`;

export const StyledChannelTag = styled.span`
  display: inline-flex;
  border-radius: 999px;
  align-items: center;
  padding: 0.25rem 0.625rem;
  ${pickThemeFontStyles('12', '16', 'SEMI_BOLD')}
  color: #475467;
  background-color: #eef1f4;
`;

export const StyledDate = styled.span`
  color: ${COLORS.GRAY_6};
`;

export const StyledId = styled.strong`
  color: ${COLORS.TEXT_PRIMARY};
`;

export const StyledActionLinkButton = styled(LinkButton)`
  width: 100%;
`;
